import type { IconProps } from './types';
import './icons.css';

export default function Right({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 7}
      height={height || 10}
      viewBox="0 0 7 10"
      className={`icon icon-right ${className || ''}`}
      fill="none"
    >
      <path d="M1 1L5 5L1 9" stroke="currentColor" />
    </svg>
  );
}
